import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  ImageListItem,
  TextField,
} from "@mui/material";
import logo from "../../assets/images/Left.png";
import BackArrow from "../../assets/icons/BackArrow.svg";
import Maskgroup from "../../assets/icons/Maskgroup.svg";
import "./login.css";
import Eye from "../../assets/icons/Eye.svg";
import EyeIcon from "../../assets/icons/EyeIcon.svg";
import Arrowicon from "../../assets/icons/Arrow.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  userForgotPassword,
  setLoaderUserLogin,
  isForgotPassword,
} from "../../redux/actions/userActions";
import { TOKEN } from "../../utils/localStorage";
import { getCookie } from "cookies-next";
import { LoadingButton } from "@mui/lab";

const styles = {
  imageListItem: {
    backgroundImage: `url(${logo})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  leftText: {
    marginTop: "30px",
    fontSize: "25px",
    fontWeight: 600,
    color: "#FFFFFF",
    margin: "10px",
  },
  contentBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: "100vh !important",
  },

  button: {
    fontSize: "25px",
    fontWeight: "bold",
    backgroundColor: "#FFFFFF",
    padding: "8px 15px 5px 15px",
    margin: "30px 10px 5px 0px",
    borderRadius: "8px",
    color: "#20704D",
    ":hover": {
      backgroundColor: "#FFFFFF",
    },
  },
};

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isLoginLoading = useSelector((state) => state?.user?.isLoginLoading);

  const IsForgotPassword = useSelector(
    (state) => state?.user?.isForgotPassword
  );


  const [loginData, setLoginData] = useState({
    email: null,
  });

  const [validationError, setValidationError] = useState(false);

  const onEmailSet = (e) => {
    setLoginData({ ...loginData, email: e.target.value });
  };

  const onSubmitForgotPwd = async (event) => {
    event.preventDefault();
    if (loginData.email !== null) {
      setValidationError(false);
      const emailPattern =
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (emailPattern.test(loginData.email)) {
        dispatch(
          userForgotPassword({
            email: loginData.email,
          })
        );
      }
    } else {
      setValidationError(true);
    }
  };

  useEffect(() => {
    dispatch(setLoaderUserLogin(false));
    dispatch(isForgotPassword(false));
  }, []);

  useEffect(() => {
    if (IsForgotPassword) {
      navigate("/");
    }
  }, [IsForgotPassword]);

  return (
    <Box className="login">
      {/*----------------------------forgotpassword leftbar ---------------------------- /> */}
      <Box className="login_left_side">
        <ImageListItem sx={styles.imageListItem}>
          <Box sx={styles.contentBox}>
            <Box>
              <ImageListItem sx={{ margin: "10px" }}>
                <img src={Maskgroup} alt="" />
              </ImageListItem>
            </Box>

            <Box>
              <Typography sx={styles.leftText} align="center">
                Planned Maintenance System (PMS)
              </Typography>
            </Box>
            <Box>
              <Typography sx={styles.button}>Harbour Tugs</Typography>
            </Box>
          </Box>
        </ImageListItem>
      </Box>
      {/*----------------------------forgotpassword rightbar ---------------------------- /> */}
      <Box className="login_right_side">
        <Box className="login_header_box">
          <>
            <form onSubmit={onSubmitForgotPwd}>
              <Box sx={{ marginBottom: "70px" }}>
                <Box>
                  <Typography
                    sx={{
                      // ml: 2,
                      fontSize: "30px",
                      fontWeight: 600,
                      color: "#2F3044",
                    }}
                  >
                    Forgot Password
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ marginTop: "20px" }}>
                <Typography
                  sx={{ fontSize: "15px", fontWeight: 600, color: "#2F3044" }}
                >
                  Email ID
                </Typography>
                <Box className="input_container">
                  <input
                    type="text"
                    className="input_field"
                    value={loginData.email}
                    onChange={onEmailSet}
                    placeholder="Enter Your Email Address"
                    // required
                  />
                </Box>
                {validationError && (
                  <Box>
                    <Typography
                      sx={{
                        marginTop: "5px",
                        fontSize: "15px",
                        color: "red",
                      }}
                    >
                      Please enter email address
                    </Typography>
                  </Box>
                )}
              </Box>
              <Box
                sx={{
                  marginTop: "20px",
                  display: "flex",
                  alignItems: "end",
                  justifyContent: "space-between",
                }}
              >
              
                <Button
                  // variant="outlined"
                  sx={{
                    fontSize: "18px",
                    fontWeight: 600, 
                    color: "#2F3044",
                    borderColor: "#26875C",
                    width: "6rem",
                    // backgroundColor: "#26875C",
                    padding: "6px 0px 4px 0px",
                    borderRadius: "10px",
                    textTransform: "capitalize",
                    // ml: "10px",
                    // ":hover": {
                    //   backgroundColor: "#26875C",
                    //   borderColor: "#26875C",
                    // },
                  }}
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  <Box sx={{ marginRight: "6px" }}>
                    <img src={BackArrow} alt="" width="14" height="14"/>
                  </Box>
                  Back
                </Button>
                <LoadingButton
                  type="submit"
                  variant="contained"
                  sx={{
                    fontSize: "15px",
                    fontWeight: 600,
                    backgroundColor: "#26875C",
                    padding: "10px 30px 8px 30px",
                    textTransform: "capitalize",
                    borderRadius: "8px",
                    color: "#FFFFFF",
                    ":hover": {
                      backgroundColor: "#26875C",
                    },
                  }}
                  size="large"
                  loading={isLoginLoading}
                >
                  Submit
                  <Box sx={{ marginLeft: "10px" }}>
                    <img src={Arrowicon} alt="" />
                  </Box>
                </LoadingButton>
              </Box>
            </form>
          </>
        </Box>
      </Box>
    </Box>
  );
};

export default ForgotPassword;
